/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank9S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13.132 11.37c.032-.182.048-.364.048-.546 0-.413-.103-.737-.31-.97-.207-.233-.493-.35-.86-.35-.36 0-.647.12-.86.36-.207.24-.31.567-.31.98 0 .253.043.477.13.67.087.193.21.343.37.45.167.1.357.15.57.15.293 0 .553-.077.78-.23a1.46 1.46 0 0 0 .442-.514z" />
        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm.459-8.964a1.84 1.84 0 0 1-.899.218c-.453 0-.847-.097-1.18-.29a1.967 1.967 0 0 1-.76-.82c-.173-.36-.26-.783-.26-1.27 0-.527.107-.983.32-1.37.22-.393.53-.697.93-.91.4-.213.867-.32 1.4-.32.833 0 1.483.233 1.95.7.467.46.7 1.107.7 1.94 0 .447-.1.937-.3 1.47a6.712 6.712 0 0 1-.86 1.56l-1.17 1.63h-1.66l1.29-1.79c.193-.266.359-.516.498-.748z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank9S as Rank9S };
